/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { IJob, IResponseListJob, IResponseShowJob } from "../../interfaces/jobs";
import { IResponseShowActivity } from "../../interfaces/activities";

const BASE = "/jobs";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function createJob({ job }: { job: Partial<IJob> }) {
  const { data } = await api.post<{job:  { id: number }}>(BASE, { job });
  return data;
}

export async function listJobs({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListJob>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showJob({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowJob>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function updateJob({
  id,
  job,
}: {
  id: string | number;
  job: IJob;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowJob>(url, { job });
  return data;
}
